module.exports = __webpack_public_path__ + "static/media/FOTO3.2a3ac849.jpg";